module.exports = __webpack_public_path__ + "static/media/twin.df75a56d.svg";